import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class GlobalState {
  public _data = new Subject<Object>();
  public _dataStream$ = this._data.asObservable();
  //sag
  public _globalSettings: Map<string, Array<any>> = new Map<string, Array<any>>();
  public _subscriptions: Map<string, Array<Function>> = new Map<string, Array<Function>>();

  constructor() {
    this._dataStream$.subscribe((data) => this._onEvent(data));
  }

  notifyDataChanged(event, value) {

    let current = this._data[event];
    if (current !== value) {
      this._data[event] = value;

      this._data.next({
        event: event,
        data: this._data[event]
      });
    }
  }

  subscribe(event: string, callback: Function) {
    let subscribers = this._subscriptions.get(event) || [];
    subscribers.push(callback);

    this._subscriptions.set(event, subscribers);
  }

  _onEvent(data: any) {
    let subscribers = this._subscriptions.get(data['event']) || [];

    subscribers.forEach((callback) => {
      callback.call(null, data['data']);
    });

  }

  setGlobalSetting(key: string, items: Array<any>) {
    this._globalSettings.set(key, items);
  }
  getGlobalSetting(key: string): Array<any> {
    return this._globalSettings.get(key);
  }
}
